import { format, parseISO } from 'date-fns';
import React from 'react';
import { Container } from './box-iterations-style';
import MessageIteration from './message-iterations';

const mapColorsIterations = {
  ANSWER_PART: {
    desc: 'Parte da resposta',
    color: '#E3FCDA',
  },
  RANDOM_WORDS: {
    desc: 'Palavras aleatórias',
    color: '#EFDAFC',
  },
  DOUBT_ABOUT_QUESTION: {
    desc: 'Dúvida sobre a pergunta',
    color: '#FCDADA',
  },
  DOUBT_OUTSIDE_CONTEXT_INTERVIEW: {
    desc: 'Dúvida fora do contexto da entrevista',
    color: '#EAEAEA',
  },
  OUTSIDE_CONTEXT_INTERVIEW: {
    desc: 'Fora do contexto da entrevista',
    color: '#FCF5DA',
  },
  undefined: {
    desc: 'Fora do contexto da entrevista',
    color: '#a78b1b',
  },
};
const formatDate = (dateString) => {
  const date = parseISO(dateString);
  return format(date, 'HH:mm');
};

const returnMarginValue = (operation) => {
  return operation ? '0px 0px 0px 0px' : '0px 0px 0px auto';
};

const returnRadiusValue = (operation) => {
  return operation ? '0px 10px 10px 10px' : '10px 10px 0px 10px';
};

const returnBgColorValue = (it) => {
  return it.iterationType === 'ASSISTANT'
    ? '#CFE2FC'
    : it.category
    ? mapColorsIterations[it.category].color
    : '#EAEAEA';
};

function BoxIterations({ iterations = [] }) {
  return (
    <Container>
      {iterations.map((it) => (
        <MessageIteration
          hour={formatDate(it.iterationDate)}
          marginValue={returnMarginValue(it.iterationType === 'ASSISTANT')}
          radiusValue={returnRadiusValue(it.iterationType === 'ASSISTANT')}
          bgColor={returnBgColorValue(it)}
          key={it.iterationDate}
          msg={it.content}
        />
      ))}
    </Container>
  );
}

export default BoxIterations;
